import { StyleSheet } from "react-native";
import { height, width } from "../../utils/utils";
export const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#CCE4FF",
    flexDirection: "row",
  },
  imgDetail: {
    maxWidth: 120,
    width: "100%",
    height: 110,
    borderRadius: 29,
  },
  viewDetail: {
    flexDirection: "row",
    paddingHorizontal: width * 0.04,
    borderTopColor: "#9cbee7",
    borderBottomWidth: 1,
    borderBottomColor: "#9cbee7",
    height: 147,
    alignItems: "center",
    justifyContent: "space-between",
  },
  textDetail: {
    fontSize: 16,
    fontFamily: "Prompt",
    color: "#2B6AB1",
    textAlign: "center",
    width: "10%",
  },
  buttomDetail: {
    width: width * 0.035,
    height: 40,
    backgroundColor: "#fff",
    borderRadius: 9,
    justifyContent: "center",
    marginHorizontal: 6,
  },
  textButtonDetail: {
    fontSize: 14,
    fontFamily: "Prompt",
    color: "#2D69AE",
    alignSelf: "center",
  },
  textButtonDetailRespons: {
    fontSize: 12,
    fontFamily: "Prompt",
    color: "#2D69AE",
    alignSelf: "center",
  },
  viewTopic: {
    flexDirection: "row",
    marginTop: 27,
    paddingBottom: 10.5,
    width: "100%",
    paddingHorizontal: width * 0.04,
    justifyContent: "space-between",
  },
  textTitle: {
    fontSize: 18,
    fontFamily: "Prompt",
    color: "#2B6AB1",
    textAlign: "center",
    width: "10%",
  },
  textTitleRespons: {
    fontSize: 16,
    fontFamily: "Prompt",
    color: "#2B6AB1",
    textAlign: "center",
    width: "10%",
  },
  viewStatusMailModal: {
    alignSelf: "center",
    borderWidth: 1,
    justifyContent: "center",
    marginTop: 40,
    height: 99,
  },
  textStatusMailModal: {
    fontFamily: "Segoe",
    alignSelf: "center",
  },
});
export const stylesResponsive = StyleSheet.create({
  textDetail: {
    fontSize: 14,
    fontFamily: "Prompt",
    color: "#2B6AB1",
  },
  buttomDetail: {
    width: width * 0.12,
    height: 40,
    backgroundColor: "#fff",
    borderRadius: 9,
    justifyContent: "center",
    marginHorizontal: 6,
  },
  textButtonDetail: {
    fontSize: 10,
    fontFamily: "Prompt",
    color: "#2D69AE",
    alignSelf: "center",
  },
  textTitle: {
    fontSize: 16,
    fontFamily: "Prompt",
    color: "#2B6AB1",
    marginTop: 10,
  },
  viewDetail: {
    flexDirection: "row",
    paddingHorizontal: width * 0.04,
    borderTopColor: "#9cbee7",
    borderBottomWidth: 1,
    borderBottomColor: "#9cbee7",
    justifyContent: "space-between",
    paddingVertical: 20,
  },
});
